import React from 'react';
import { 
  Wifi, Waves, Utensils, BookOpen, Gamepad2, 
  Monitor, Printer, Trophy, Shield 
} from 'lucide-react';
import { amenities } from '../data/content';

const iconMap = {
  Wifi,
  Waves,
  Utensils,
  BookOpen,
  Gamepad2,
  Monitor,
  Printer,
  Trophy,
  Shield
};

export const AmenitiesSection = () => {
  return (
    <section data-testid="amenities-section" className="section-spacing bg-gradient-to-b from-orange-50 to-white relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-teal-500/10 rounded-full blur-3xl" />
      <div className="absolute top-20 right-20 w-64 h-64 bg-coral/10 rounded-full blur-3xl" />
      
      <div className="section-container relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block px-4 py-2 bg-teal-100 text-teal-600 rounded-full text-sm font-semibold mb-4">
            All Inclusive
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 font-['Outfit']">
            World-Class <span className="text-coral">Amenities</span>
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Everything you need for comfortable student living, included in your rent.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {amenities.map((amenity, idx) => {
            const Icon = iconMap[amenity.icon] || Shield;
            const isLarge = idx === 0 || idx === 8;
            
            return (
              <div
                key={amenity.id}
                data-testid={`amenity-${amenity.id}`}
                className={`bg-white rounded-2xl p-6 flex flex-col items-center justify-center text-center border border-orange-100 hover:border-coral/30 hover:shadow-lg transition-all ${
                  isLarge ? 'md:col-span-2 md:row-span-2' : ''
                }`}
              >
                <div className={`${isLarge ? 'w-20 h-20 mb-6' : 'w-14 h-14 mb-4'} bg-gradient-to-br from-coral/20 to-orange/20 rounded-2xl flex items-center justify-center`}>
                  <Icon className={`${isLarge ? 'w-10 h-10' : 'w-7 h-7'} text-coral`} />
                </div>
                <h3 className={`font-semibold text-slate-900 font-['Outfit'] ${isLarge ? 'text-xl' : 'text-base'}`}>
                  {amenity.name}
                </h3>
                {isLarge && (
                  <p className="mt-2 text-slate-500 text-sm">
                    {amenity.id === 1 ? 'High-speed internet throughout the premises' : 'Round-the-clock protection for your peace of mind'}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
